import React from 'react'
import {
  GreetingCardImage,
  GreetingCardImageLinkType,
} from './GreetingCardImage'
import { Flex } from '@sendoutcards/quantum-design-ui'

type CarouselCardImages = {
  cards: GreetingCardImageLinkType[]
  cardHeight?: string
  cardWidth?: string
  cardRadius?: number
  gap?: string
}

export const CarouselCardImages: React.FC<CarouselCardImages> = ({
  cards,
  cardHeight = '225px',
  cardWidth = '155px',
  cardRadius = 6,
  gap = '30px',
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection={'row'}
      position="relative"
      left="50%"
      transform={'translateX(-50%)'}
      style={{ gap: gap }}
      flexShrink={0}
    >
      {cards.slice(0, 3).map((c, index) => {
        const width = c.isHorizontal ? cardHeight : cardWidth
        const height = c.isHorizontal ? cardWidth : cardHeight
        const isCenterCard = index === 1

        return (
          <GreetingCardImage
            key={c.cardId}
            previewUrl={c.previewUrl}
            cardId={c.cardId}
            width={width}
            height={height}
            zIndex={isCenterCard ? 3 : index}
            scale={isCenterCard ? 1 : 0.9}
            radius={cardRadius}
          />
        )
      })}
    </Flex>
  )
}
